import type {
  ActivitySuggestionsResponse,
  ActivitySuggestionsSearchCriteria,
  GraphQL,
} from '@libs/trip-planner-interfaces';
import { assertValue } from '@libs/utils';

import { getApolloClient } from './infrastructure';
import { GET_SUGGESTED_QUERY } from './queries';
import { getSuggestedAvailabilityRequestQL } from './utils/requestMappers/getSuggestedAvailabilityRequestQL';
import { toActivitySuggestionsResponse } from './utils/responseMappers/activitySuggestionsResponseQL';

export class ActivitySuggestionService {
  public async getSuggestions(
    criteria: ActivitySuggestionsSearchCriteria
  ): Promise<ActivitySuggestionsResponse> {
    const request = getSuggestedAvailabilityRequestQL(criteria);

    const response = await getApolloClient().query<
      GraphQL.GetSuggestedQuery,
      GraphQL.GetSuggestedQueryVariables
    >({
      query: GET_SUGGESTED_QUERY,
      variables: { request },
    });

    assertValue(
      response.data,
      'activitySuggestionService > getSuggestions > response data not available'
    );

    return toActivitySuggestionsResponse(
      response.data,
      request.ingredientIndex
    );
  }
}
